import { render, staticRenderFns } from "./ModalAttendance.vue?vue&type=template&id=447fef36&"
import script from "./ModalAttendance.vue?vue&type=script&lang=js&"
export * from "./ModalAttendance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports